// extracted by mini-css-extract-plugin
export default {"card":"news-card_card__SKaC8","content":"news-card_content__y93Kj","publishedDate":"news-card_publishedDate__H1AyI"};